<template>
 <headers />
  <div class="info">
  <div id="mainCharts" :style="{ width: '1200px', height: '800px' }"></div>
  </div>
</template>
<style>
.info {
  width: 98%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 50px;
}
</style>
<script>
import headers from "../views/Home.vue";
import * as echarts from "echarts";
import { GetCharts } from "../http/api.ts";
import { reactive } from "@vue/reactivity";
export default {
   components: {
    headers,
  },
  setup() {
    let info = reactive({
      count: "",
      times: "",
    });
    let GetChart=async()=>{
      GetCharts().then((res) => {
          if (res.code == 200) {
            info.count = res.datas.Count;
            info.times = res.datas.Times;
          }         
        })
    }
    GetChart();
    setTimeout(function () {      
      let drawLine = async () => {  
        var chartDom = document.getElementById("mainCharts");
        var myChart = echarts.init(chartDom);
        var option;

        option = {
          xAxis: {
            type: "category",
            data: Array.from(info.times),
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: Array.from(info.count),
              type: "line",
            },
          ],
        };

        option && myChart.setOption(option);
      };

      drawLine();
      return {
        drawLine,
      };
    }, 5000);
  },
  methods: {},
};
</script>